/* eslint-disable react/no-unescaped-entities */
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import parse from "date-fns/parse";
import { useIntl } from "react-intl";
import PolicyPage from "../components/policies/PolicyPage";

function AntiPiracyTerms() {
  const intl = useIntl();
  if (!intl.locale.startsWith("pt")) {
    return (
      <>
        <FundamenteiMetadata title="Anti-Piracy Terms and Conditions | Fundamentei" />
        <PolicyPage
          title="Anti-Piracy Terms and Conditions"
          lastUpdatedAt={parse("2023-10-25", "yyyy-MM-dd", new Date())}
        >
          <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
            <p>
              Fundamentei Serviços de Informação LTDA (“We”), CNPJ 35.804.692/0001-05, establishes guidelines and rules
              for the use of any content protected by copyright, intellectual property, or any other form of legal
              ownership ("Protected Content") provided by us. Unauthorized use of Protected Content is strictly
              prohibited and subject to legal action. By accessing or using the Protected Content, you agree to these
              Terms. We recommend careful reading.
            </p>
            <ul>
              <li className="list-none">
                <strong>1. Definitions</strong>
              </li>
              <li>
                <p>
                  1.1. Protected Content: Refers to any work protected by copyright, software, design, trademarks,
                  videos from the Fundamentei Black platform and Caixa Preta Fundamentei, or any other intellectual
                  property material made available by us.
                </p>
              </li>
              <li>
                <p>
                  1.2. User: You, the person or entity that accesses, uses, or attempts to access or use the Protected
                  Content.
                </p>
              </li>
              <li className="list-none">
                <strong>2. Copyright and Intellectual Property Rights</strong>
              </li>
              <li>
                <p>
                  2.1. The user agrees to respect and not violate the copyright or any other intellectual property
                  rights associated with the Protected Content. You must not copy, distribute, reproduce, modify,
                  display, perform, create derivative works, or use the Protected Content in an unauthorized manner.
                </p>
              </li>
              <li className="list-none">
                <strong>3. Authorized Use</strong>
              </li>
              <li>
                <p>
                  3.1. Authorized use of the Protected Content is limited to what is expressly and unequivocally
                  permitted by us. Any specific terms regarding authorized use will be provided clearly and in detail in
                  a separate document.
                </p>
              </li>
              <li className="list-none">
                <strong>4. Prohibition of Piracy and Violation</strong>
              </li>
              <li>
                <p>
                  4.1. You agree not to engage in piracy activities, including, but not limited to, copying,
                  distributing, selling, sharing, publicly making available, or any other unauthorized dissemination of
                  Protected Content.
                </p>
              </li>
              <li>
                <p>
                  4.2. We reserve the right to monitor and detect piracy activities. Violation of these Terms will
                  subject you to legal actions, including but not limited to, lawsuits to enforce our rights and seek
                  compensation for damages, and reports to the relevant authorities (ANPD, Public Prosecutor’s Office,
                  Federal/Civil Police, among others).
                </p>
              </li>
              <li className="list-none">
                <strong>5. Reporting and Notification of Violations</strong>
              </li>
              <li>
                <p>
                  5.1. If you believe that Protected Content has been used without authorization by third parties,
                  please contact us at the following email address: contato@fundamentei.com. We will take recommended
                  measures to investigate and rectify any detected violation.
                </p>
              </li>
              <li className="list-none">
                <strong>6. Changes to the Terms</strong>
              </li>
              <li>
                <p>
                  6.1. We reserve the right to change this document at any time. Any changes will be published on our
                  website or through other forms of communication. Continued use of the Protected Content after changes
                  are implemented will signify your acceptance of those changes.
                </p>
              </li>
              <li className="list-none">
                <strong>7. Conclusion</strong>
              </li>
              <li>
                <p>
                  7.1. This document constitutes the entire agreement between the user and us regarding the use of the
                  Protected Content. It replaces all prior or contemporaneous communications, written or oral.
                </p>
              </li>
              <li>
                <p>
                  7.2. The content available on the platform is intended exclusively for private display. Any other
                  forms of use, such as public display, display via TV or cable TV, public screening rooms, reproduction
                  of new copies, and violations of the exclusive rights of the producer and licensed distributor, are
                  prohibited. Violation of rights regarding audiovisual works is a crime, as stated in Article 184 of
                  the Penal Code, with penalties ranging from 3 months to 4 years of imprisonment and/or fines.
                </p>
              </li>
              <li>
                <p>
                  7.3. These Terms are governed by the laws of Brazil, respecting all other laws and international
                  treaties to which Brazil is a party, and any disputes arising or related to them will be submitted to
                  the exclusive jurisdiction of the courts of that jurisdiction.
                </p>
              </li>
              <li>
                <p>
                  By accepting these terms, you acknowledge that you understand and agree to comply with the rules and
                  guidelines regarding the use of the Protected Content. Non-compliance with these terms may result in
                  legal consequences.
                </p>
              </li>
            </ul>
          </div>
        </PolicyPage>
      </>
    );
  }
  return (
    <>
      <FundamenteiMetadata title="Termos e Condições de Uso Anti-Pirataria | Fundamentei" />
      <PolicyPage
        title="Termos e Condições de Uso Anti-Pirataria"
        lastUpdatedAt={parse("2023-10-25", "yyyy-MM-dd", new Date())}
      >
        <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
          <p>
            A Fundamentei Serviços de Informação LTDA (“Nós”), CNPJ 35.804.692/0001-05, estabelece as diretrizes e
            regras para o uso de qualquer conteúdo protegido por direitos autorais, propriedade intelectual, ou qualquer
            outra forma de propriedade legal ("Conteúdo Protegido") fornecido por nós. O uso não autorizado de Conteúdo
            Protegido é estritamente proibido e sujeito a medidas legais. Ao acessar ou utilizar o Conteúdo Protegido,
            você concorda com estes Termos. Orientamos a leitura com atenção.
          </p>
          <ul>
            <li className="list-none">
              <strong>1. Definições</strong>
            </li>
            <li>
              <p>
                1.1. Conteúdo Protegido: Refere-se a qualquer obra protegida por direitos autorais, software, design,
                marca registrada, vídeos da plataforma Fundamentei Black e Caixa Preta Fundamentei ou qualquer outro
                material de propriedade intelectual disponibilizado por Nós.
              </p>
            </li>
            <li>
              <p>
                1.2. Usuário: Você, a pessoa ou entidade que acessa, utiliza, ou tenta acessar ou utilizar o Conteúdo
                Protegido.
              </p>
            </li>
            <li className="list-none">
              <strong>2. Direitos Autorais e Propriedade Intelectual</strong>
            </li>
            <li>
              <p>
                2.1. O usuário concorda em respeitar e não violar os direitos autorais ou quaisquer outros direitos de
                propriedade intelectual associados ao Conteúdo Protegido. Você não deve copiar, distribuir, reproduzir,
                modificar, exibir, executar, criar obras derivadas, ou usar o Conteúdo Protegido de forma não
                autorizada.
              </p>
            </li>
            <li className="list-none">
              <strong>3. Uso Autorizado</strong>
            </li>
            <li>
              <p>
                3.1. O uso autorizado do Conteúdo Protegido é limitado àquele permitido por Nós de forma expressa e
                inequívoca. Quaisquer termos específicos relativos ao uso autorizado serão fornecidos de forma clara e
                detalhada em documento próprio.
              </p>
            </li>
            <li className="list-none">
              <strong>4. Proibição de Pirataria e Violação</strong>
            </li>
            <li>
              <p>
                4.1. Você concorda em não se envolver em atividades de pirataria, incluindo, mas não se limitando a,
                cópia, distribuição, venda, compartilhamento, disponibilização pública, ou qualquer outra forma de
                disseminação não autorizada de Conteúdo Protegido.
              </p>
            </li>
            <li>
              <p>
                4.2. Reservamo-nos o direito de monitorar e detectar atividades de pirataria. A violação destes Termos
                sujeitará você a medidas legais, incluindo, mas não se limitando a, ações judiciais para fazer valer
                nossos direitos e buscar reparação por danos e denúncias aos órgãos competentes (ANPD, Ministério
                Público, Polícia Federal/Civil e entre outros).
              </p>
            </li>
            <li className="list-none">
              <strong>5. Denúncias e Notificação de Violação</strong>
            </li>
            <li>
              <p>
                5.1. Se você acredita que o Conteúdo Protegido foi usado de forma não autorizada por terceiros, entre em
                contato conosco por meio do seguinte endereço de e-mail: contato@fundamentei.com. Tomaremos as medidas
                recomendadas para investigar e corrigir qualquer violação detectada.
              </p>
            </li>
            <li className="list-none">
              <strong>6. Alterações nos Termos</strong>
            </li>
            <li>
              <p>
                6.1. Reservamo-nos o direito de alterar este documento a qualquer momento. Quaisquer alterações serão
                publicadas em nosso site ou por meio de outras formas de comunicação. O uso contínuo do Conteúdo
                Protegido após a implementação de alterações significará sua aceitação dessas alterações.
              </p>
            </li>
            <li className="list-none">
              <strong>7. Conclusão</strong>
            </li>
            <li>
              <p>
                7.1. Este documento constitui acordo integral entre o usuário e nós no que diz respeito ao uso do
                Conteúdo Protegido. Eles substituem todas as comunicações anteriores ou contemporâneas, escritas ou
                orais.
              </p>
            </li>
            <li>
              <p>
                7.2. O conteúdo disponível na plataforma destina-se exclusivamente a exibição privada. É proibida toda e
                qualquer outra forma de utilização, tais como: exibição ao público, exibição por TV ou TV a cabo, salas
                públicas de exibição, reprodução de novas cópias, a violação dos direitos exclusivos do produtor e do
                distribuidor licenciado e todas as outras aplicações previstas em lei. A violação dos direitos sobre a
                obra audiovisual é crime, previsto no art. 184 do Código Penal, cuja pena pode variar de 3 meses a 4
                anos de reclusão e/ou multa
              </p>
            </li>
            <li>
              <p>
                7.3. Este Termo é regido pelas leis do Brasil, respeitadas todas as demais legislações e tratados
                internacionais dos quais o Brasil participa, e quaisquer disputas decorrentes ou relacionadas a eles
                serão submetidas à jurisdição exclusiva dos tribunais dessa jurisdição.
              </p>
            </li>
            <li>
              <p>
                Ao aceitar esses termos, você reconhece que entendeu e concorda em respeitar as regras e diretrizes
                relativas ao uso do Conteúdo Protegido. O não cumprimento destes termos pode resultar em consequências
                legais.
              </p>
            </li>
          </ul>
        </div>
      </PolicyPage>
    </>
  );
}

export default AntiPiracyTerms;
